import HeroComponent from '../components/hero';

export default class sustainabilitysnapshot2021Controller {

  constructor(options) {
    this.options = options;
    console.log('SUSTAINABILITYSNAPSHOT2021 CONTROLLER');

    var flipbookEL = document.getElementById('flipbook');

    window.addEventListener('resize', function (e) {
        flipbookEL.style.width = '';
      flipbookEL.style.height = '';
      $(flipbookEL).turn('size', flipbookEL.clientWidth, flipbookEL.clientHeight);
    });

    $(flipbookEL).turn({
        autoCenter: true,
        duration:300,
        gradients:false
    });

    	$(document).keydown(function(e){

		var previous = 37, next = 39, esc = 27;

		switch (e.keyCode) {
			case previous:

				// left arrow
				$(flipbookEL).turn('previous');
				e.preventDefault();

			break;
			case next:

				//right arrow
				$(flipbookEL).turn('next');
				e.preventDefault();

			break;
		}
	});

	$('.next').click(function() {
        $('.prev').removeClass('hide');

		$(flipbookEL).turn('next');

		if($(flipbookEL).turn('page') ==  4){
		    $('.next').addClass('hide');
        }

	});
	$('.prev').click(function() {
        $('.next').removeClass('hide');

		$(flipbookEL).turn('previous');

		if($(flipbookEL).turn('page') ==  1){
		    $('.prev').addClass('hide');
        }
	});

    // ** NOTE: if we allow for more than one gallery, we would
    // iterate over the .blog__gallery elems and start a
    // flickity for each one. **


    $('nav.siteNav__main>div>a.submenu__csr').addClass('is-activepage');

    this.transitionIn();

  }

  transitionIn() {
    // reveal the home hero text
    $('.welfare__hero .cmpnt__hero__copy__cntr').addClass('do-intro');

    setTimeout( () => {
      $('.welfare__hero .cmpnt__hero__copy__cntr').removeClass('do-intro start-intro');
    }, 2300);

  }

}



// WEBPACK FOOTER //
// ./js/controllers/pages/sustainabilitysnapshot2021Controller.js